"use strict";

import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import BaseControl from "D5Utils/form_fields/BaseControl";

var MultiSelectControl =
/*#__PURE__*/
function (_BaseControl) {
  _inherits(MultiSelectControl, _BaseControl);

  function MultiSelectControl(props) {
    var _this;

    _classCallCheck(this, MultiSelectControl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MultiSelectControl).call(this, props));
    if (_this.value != null && !Array.isArray(_this.value)) _this.value = [_this.value];
    return _this;
  }

  _createClass(MultiSelectControl, [{
    key: "_buildControlProps",
    value: function _buildControlProps() {
      var _this2 = this;

      var props = _objectSpread({
        searchEnabled: true,
        showClearButton: true,
        showSelectionControls: true,
        applyValueMode: 'useButtons'
      }, this.props, {
        value: this.value,
        onValueChanged: function onValueChanged(e) {
          if (typeof _this2.props.onValueChanged === 'function') {
            _this2.props.onValueChanged(e);
          }
        }
      });

      return props;
    }
  }, {
    key: "instance",
    value: function instance() {
      return this.$_element.dxTagBox('instance');
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.$_element.dxTagBox('dispose');
      this.$_element.remove();
    }
  }, {
    key: "render",
    value: function render() {
      this.$_element = this.$_element.dxTagBox(_objectSpread({}, this._buildControlProps()));
    }
  }]);

  return MultiSelectControl;
}(BaseControl);

export { MultiSelectControl as default };